import React, { forwardRef } from "react";
import SelectOption from "../../../../../../components/SelectOption";
import { useApi } from "../../../../../../hooks/http2";
import { URL_API, _ } from "../../../../../../utils";

const SelectProductCategory = (props) => {
  const list = useApi(
    {
      url: `${URL_API}/system/master/product_category`,
      token: true,
    },
    []
  );

  return (
    <SelectOption
      loading={list.loading}
      data={_.map(list.fetch?.data || [], (n) => ({
        value: n.code?.toString(),
        text: n.name,
      }))}
      withAll
      allText="เลือกหมวดสินค้า"
      {...props}
    />
  );
};

export default forwardRef((props, ref) => {
  return <SelectProductCategory forwardRef={ref} {...props} />;
});
